import { DataBean } from "../DataBean";

export class PayrollEntity extends DataBean {

    public async getPayrollEntityCatalog(idPayrollEntity: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getPayrollEntityCatalog_Number", [idPayrollEntity]);
    }

    public async deletePayrollEntity(idPayrollEntity: number): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deletePayrollEntity_Number", [idPayrollEntity]);
    }

    public async updatePayrollEntity(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.loans.PayrollEntity_updatePayrollEntity_com.quickdataerp.bean.loans.PayrollEntity", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.loans.PayrollEntity"
            }
        ]);
    }

}
